import { render, staticRenderFns } from "./TodoLabel.vue?vue&type=template&id=205287de&"
import script from "./TodoLabel.vue?vue&type=script&lang=js&"
export * from "./TodoLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports